import { Component, OnInit, Input } from '@angular/core';
import { CartService } from '../../shared/services/cart.service';
import { Selfservice, SsOrder, SsBill, SsOrderItem } from '../../shared/models/selfservice';
import { faClock } from '../../icons';
@Component({
  selector: 'app-ssbill',
  templateUrl: './ssbill.component.html',
  styleUrls: ['./ssbill.component.scss'],
  standalone: false
})
export class SsbillComponent implements OnInit {
    faClock = faClock;
  @Input() selfservice: Selfservice;
  
  bill: SsBill;

  items: SsOrderItem[] = [];

  constructor(private cart: CartService) { }

  ngOnInit(): void {
    this._getBillItems();
    this._getLocalItems();
    SsOrderItem.setAdditionalData(this.items);
    console.log(this.bill);
  }

  private _getBillItems() {
    this.bill = Selfservice.getBill(this.selfservice);

    let aux: SsOrderItem[] = [];

    if(this.bill && this.bill.items) {
      aux = this.bill.items;
    }

    for(let item of aux) {
      item.status = 'received';
      this.items.push(item);
    }
  }
  private _getLocalItems() {
    for(let item of Selfservice.getPendingItems(this.selfservice, this.cart.getLocalOrders())) {
      item.status = 'pending';
      this.items.push(item);
    }
  }
}
